import {
    AD_SLOT_REFRESH,
    AD_SLOT_RENDER_ENDED,
    AdSlotRefreshAction,
    AdSlotRenderEndedAction,
} from "@/mk2/containers/AdSlot/AdSlot.actions";
import { PREFIX_AD_SLOT_ANCHOR_LEADERBOARD } from "@/mk2/containers/AdSlotAnchorLeaderboard/AdSlotAnchorLeaderboard";
import {
    AD_SLOT_ANCHOR_LEADERBOARD_CLOSE_BY_USER,
    AdSlotAnchorLeaderboardCloseByUserAction,
} from "@/mk2/containers/AdSlotAnchorLeaderboard/AdSlotAnchorLeaderboard.actions";

export interface AdSlotAnchorLeaderboardState {
    adSlotSize: null;
    adSlotRenderEnded: boolean;
    adSlotClosedByUser: boolean;
}

export const initialAdSlotAnchorLeaderboardState: AdSlotAnchorLeaderboardState = {
    adSlotSize: null,
    adSlotRenderEnded: false,
    adSlotClosedByUser: false,
};

type AdSlotActions =
    | AdSlotRenderEndedAction
    | AdSlotRefreshAction
    | AdSlotAnchorLeaderboardCloseByUserAction;

export const adSlotAnchorLeaderboardReducer = (
    state: AdSlotAnchorLeaderboardState = initialAdSlotAnchorLeaderboardState,
    action: AdSlotActions,
) => {
    switch (action.type) {
        case AD_SLOT_REFRESH:
            // We handle only anchor leaderboard ads
            if (!action.slotId.startsWith(PREFIX_AD_SLOT_ANCHOR_LEADERBOARD)) {
                return state;
            }

            return {
                ...state,
                // this slot has been scheduled for refresh - hide slot
                adSlotRenderEnded: false,
            };
        case AD_SLOT_RENDER_ENDED:
            // We handle only anchor leaderboard ads
            if (!action.slotId.startsWith(PREFIX_AD_SLOT_ANCHOR_LEADERBOARD)) {
                return state;
            }

            return {
                ...state,
                adSlotSize: action.event.size,
                adSlotRenderEnded: !action.event.isEmpty,
                adSlotClosedByUser: false,
            };
        case AD_SLOT_ANCHOR_LEADERBOARD_CLOSE_BY_USER:
            return {
                ...state,
                adSlotClosedByUser: action.closed,
            };
        default:
            return state;
    }
};
